// 前提：source/js/main.js の DOMContentLoaded 内で loopSlider() を呼び出すこと
//   import { loopSlider } from './modules/loop-slider';
//   document.addEventListener('DOMContentLoaded', () => { loopSlider(); });
//
// HTML 仕様:
// - .js-loop-slider 内に .m-loop-slider__item（1個以上）を配置
// - JS が viewport 幅 × 2 以上になるまでセット単位で item を複製
// - アニメーションは 1 セット分（オリジナル item 群の合計幅）だけ translateX
// - 速度: data-loop-slider-speed="<px/s>"（デフォルト 80）
// - 逆方向は CSS の .m-loop-slider--reverse モディファイアで対応（JS は関与しない）
// - hover 停止も CSS の .m-loop-slider--pause-on-hover モディファイアで対応

// デフォルト速度（px/s）
const DEFAULT_SPEED_PX_PER_SEC = 80;

/**
 * ループ等速スライダーの初期化
 * - .m-loop-slider__item の合計幅を 1 セットとして、viewport 幅 × 2 になるまで複製
 * - translate / duration を CSS 変数で設定して継ぎ目なくループ
 */
const loopSlider = () => {
  const tracks = document.querySelectorAll('.js-loop-slider');
  if (!tracks.length) return;

  const setup = (track) => {
    // JS が作成した複製のみを削除（開発者が手動で付けた aria-hidden item は残す）
    [...track.children].forEach((child) => {
      if (child.dataset.loopSliderClone === 'true') child.remove();
    });

    const items = [...track.children];
    if (!items.length) return;

    const setWidth = items.reduce((sum, el) => sum + el.offsetWidth, 0);
    if (!setWidth) return;

    const appendClone = (item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.loopSliderClone = 'true';
      track.appendChild(clone);
    };

    // viewport 幅 × 2 以上になるまでセット単位で複製
    const targetWidth = window.innerWidth * 2;
    let totalWidth = setWidth;
    while (totalWidth < targetWidth) {
      items.forEach(appendClone);
      totalWidth += setWidth;
    }

    // 最低 2 セット必要（シームレスループのため）
    if (totalWidth < setWidth * 2) {
      items.forEach(appendClone);
    }

    // 速度設定（data-loop-slider-speed > 0 ならそれを使う、それ以外はデフォルト）
    const speedAttr = parseFloat(track.dataset.loopSliderSpeed);
    const speed =
      Number.isFinite(speedAttr) && speedAttr > 0
        ? speedAttr
        : DEFAULT_SPEED_PX_PER_SEC;
    const duration = setWidth / speed;

    track.style.setProperty('--loop-slider-translate', `-${setWidth}px`);
    track.style.setProperty('--loop-slider-duration', `${duration}s`);
  };

  tracks.forEach(setup);

  // viewport 幅変化に追従して setup を再実行（拡大時の隙間防止）
  // requestAnimationFrame で連続発火を 1 フレームにコアレス
  if (typeof ResizeObserver !== 'undefined') {
    let rafId = 0;
    const ro = new ResizeObserver(() => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => tracks.forEach(setup));
    });
    ro.observe(document.documentElement);
  }
};

export { loopSlider };
